<script lang="ts" setup>
import NewsListItem from '@/components/news/NewsListItem.vue'
import { NewsItem } from '@/helper/Types'
import { onMounted } from 'vue'
import { UnreadNewsService } from '@/services/UnreadNewsService'

const props = defineProps<{
  news: NewsItem[]
}>()

onMounted(() => UnreadNewsService.markAsRead(props.news.map(n => n.id!)))
</script>

<template>
  <div class="news-list">
    <div class="fTable card">
      <div class="fTable__tr has--th">
        <div class="fTable__th column">
          {{ $t('news.content') }}
        </div>
        <div class="fTable__th column">
          {{ $t('news.date') }}
        </div>
      </div>

      <NewsListItem v-for="item in news" :key="item.id" :item="item" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.column {
  &:not(:first-child) {
    justify-content: flex-end;
    flex-basis: 20%;
  }
}
</style>
